import React from 'react';
import { useTranslation } from 'react-i18next';
import videoSmMd from '../assets/Home/1003(1).mp4';
import videoLg from '../assets/Home/1003.mp4';

const HomeHero = () => {
    const { t } = useTranslation();

    return (
        <section className="relative min-h-screen w-full overflow-hidden">
            {/* Video for sm and md screens */}
            <video
                className="absolute inset-0 w-full h-full object-cover lg:hidden"
                autoPlay
                loop
                muted
                playsInline
            >
                <source src={videoSmMd} type="video/mp4" />
                {t('homeHeroSection.videoFallback')}
            </video>

            {/* Video for lg and larger screens */}
            <video
                className="absolute inset-0 w-full h-full object-cover hidden lg:block"
                autoPlay
                loop
                muted
                playsInline
            >
                <source src={videoLg} type="video/mp4" />
                {t('homeHeroSection.videoFallback')}
            </video>

            {/* Overlay */}
            <div className="absolute inset-0 bg-black bg-opacity-60"></div>

            {/* Text Content */}
            <div className="relative z-10 flex flex-col items-center justify-center min-h-screen text-center px-4 sm:px-8 lg:px-16">
                <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-extrabold text-white mb-6 sm:mb-8 tracking-tight drop-shadow-md animate-fade-in">
                    {t('homeHeroSection.title')}
                </h1>
                <p className="text-lg sm:text-xl md:text-2xl lg:text-3xl text-gray-100 max-w-4xl mx-auto mb-8 sm:mb-10 leading-relaxed animate-fade-in delay-100">
                    {t('homeHeroSection.subtitle')}
                </p>
                <a
                    href="/tour"
                    className="px-8 py-4 bg-[#C58E2F] text-white font-semibold rounded-lg shadow-md hover:bg-[#A57324] hover:shadow-lg transform hover:scale-105 transition-all duration-200 text-base sm:text-lg animate-fade-in delay-200"
                >
                    {t('homeHeroSection.bookButton')}
                </a>
            </div>
        </section>
    );
};

export default HomeHero;